import React, { useState, useEffect } from 'react';
import './Login.css';
import API_CONFIG from './config';

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');
  const [loading, setLoading] = useState(false);

  // Si la sesión expiró (apiFetch detectó un 401/403), avisamos al usuario.
  useEffect(() => {
    if (sessionStorage.getItem('sesionExpirada')) {
      setAviso('Tu sesión expiró. Por favor, volvé a iniciar sesión.');
      sessionStorage.removeItem('sesionExpirada');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_CONFIG.BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Error al iniciar sesión');
      }
      const data = await res.json();
      localStorage.setItem('token', data.token);
      localStorage.setItem('usuario', JSON.stringify({ username: data.username, nombre: data.nombre, rol: data.rol }));
      onLogin(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">🐄</div>
        <h1 className="login-title">Sistema Medalla Milagrosa</h1>
        <p className="login-subtitle">Ingresá tus credenciales para continuar</p>

        <form onSubmit={handleSubmit} className="login-form">
          {aviso && <div className="login-aviso">{aviso}</div>}
          {error && <div className="login-error">{error}</div>}
          <div className="login-group">
            <label>Usuario</label>
            <input
              type="text"
              value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
              placeholder="Ej: admin"
              required
              autoFocus
            />
          </div>
          <div className="login-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
